<script setup lang="ts">
import { useToastsStore } from '@/stores/toasts';

const store = useToastsStore();
</script>

<template>
  <Teleport to="#toasts">
    <div :class="classes.container">
      <transition-group
        :enter-active-class="classes['list-enter-active']"
        :leave-active-class="classes['list-leave-active']"
        :enter-from-class="classes['list-enter-from']"
        :leave-to-class="classes['list-leave-to']"
        :move-class="classes['list-move']"
        tag="div"
        :class="classes.list"
      >
        <div
          v-for="toast in store.toasts"
          :key="toast.id"
          :class="[
            classes.toast,
            {
              [classes[`accent-${toast.accent.toLowerCase()}`]]: toast.accent,
            },
          ]"
        >
          <button :class="classes.close" @click="store.hide(toast.id)">
            <ISvgCloseCircle :class="classes['close-icon']" />
          </button>

          <p :class="classes.text">{{ toast.text }}</p>

          <div v-if="toast.action" :class="classes.divider" />

          <button v-if="toast.action" :class="classes.action" @click="toast.action.onClick">
            {{ toast.action.label }}
          </button>
        </div>
      </transition-group>
    </div>
  </Teleport>
</template>

<style lang="scss" module="classes" src="./Toasts.scss" />
